import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {
  TNotification,
  notificationSelector,
  setIsError,
  setIsLoading,
  setNotifications,
  setPagination,
  setUnreadNotifications,
} from 'src/redux/slices/notificationSlices'
import {fetchNotifications} from 'src/services/fetcher'

export const useNotificationFetcher = () => {
  const dispatch = useAppDispatch()
  const auth = useAppSelector(authSelector)
  const {searchParams} = useAppSelector(notificationSelector)

  const handleFetchUnreadNotifications = () => {
    dispatch(setIsLoading(true))

    const is_read = false
    const per_page = 65000000
    const credentials = auth.credential
    if (!credentials) return

    fetchNotifications({credentials, per_page, is_read})
      .then((res) => {
        dispatch(setIsError(''))
        const {data, ...rest} = res.data.data
        dispatch(setUnreadNotifications(data as TNotification[]))
      })
      .catch((err) => dispatch(setIsError(err.message ?? 'Internal server error')))
      .finally(() => dispatch(setIsLoading(false)))
  }

  const handleFetchNotifications = () => {
    dispatch(setIsLoading(true))

    const credentials = auth.credential
    if (!credentials) return

    fetchNotifications({credentials, ...searchParams})
      .then((res) => {
        const {data, ...rest} = res.data.data
        dispatch(setNotifications(data as TNotification[]))
        dispatch(setPagination(rest))
      })
      .catch((err) => dispatch(setIsError(err)))
      .finally(() => dispatch(setIsLoading(false)))
  }

  return {handleFetchUnreadNotifications, handleFetchNotifications}
}
